import type { ExternalTableSchema } from '@packages/table-builder';

export const brokerageAccountHistoryTable: ExternalTableSchema = {
  metadata: {
    title: 'Brokerage Account History',
    entity: 'brokerage-account-history',
  },
  dataSource: {
    endpoint:
      '/api/customer/api/app/participant-broker-account-updated-history/broker-account-updated-history-by-participant-broker-account-id/{ParticipantBrokerAccountId}',
    method: 'GET',
    rowIdField: 'participantBrokerAccountId',
    pathParams: { ParticipantBrokerAccountId: 'participantBrokerAccountId' },
  },
  columns: [
    { field: 'oldAccountNumber', header: 'Old Account Number', type: 'text', width: 200 },
    { field: 'updatedAccountNumber', header: 'Updated Account Number', type: 'text', width: 200 },
    { field: 'oldBrokerAccountStatusId', header: 'Old Broker Status', type: 'text', width: 180 },
    { field: 'updatedBrokerAccountStatusId', header: 'Updated Broker Status', type: 'text', width: 180 },
    { field: 'brokerName', header: 'Broker', type: 'text', width: 180 },
  ],
  actions: {},
  features: {
    pagination: { mode: 'none' },
    columnPreferences: { persistenceKey: 'Brokerage Account History', resizable: true, reorderable: true },
  },
};
